import { Pipe, PipeTransform } from '@angular/core';
import { Visitor } from '../../models';

@Pipe({ name: 'platformFormat', standalone: true })
export class PlatformFormatPipe implements PipeTransform {
  
	transform(val: string) {
        if (!val) return '';
        
        if (val === "Messenger") return '<img src="/assets/media/logos/messenger.svg" width="16px" /> Messenger';
        else if (val === "Whatsapp") return '<img src="/assets/media/logos/whatsapp.svg" width="16px" /> WhatsApp';
        else if (val === "Telegram") return '<img src="/assets/media/logos/telegram.svg" width="16px" /> Telegram';
        else if (val === "Instagram") return '<img src="/assets/media/logos/instagram.svg" width="16px" /> Instagram';

        var s = val.split(',');
        var d = s[1];
        if (s[0].toLowerCase() !== 'other') d = d + ' on ' + s[0];

        return d;
    }
}